const mapStyle = require('../mapstyle-dark-grey.json');

export default {
  init() {
    function handleLocationError(browserHasGeolocation, infoWindow, pos) {
      infoWindow.setPosition(pos);
      infoWindow.setContent(browserHasGeolocation ?
                            'Error: The Geolocation service failed.' :
                            'Error: Your browser doesn\'t support geolocation.');
      infoWindow.open(map);
      $('.archive-map-locate').removeClass('loading');
    }

    function selectIwHome($indicator) {
      $('.iw-home, .iw-home-select').removeClass('active');
      $indicator.addClass('active');
      $($indicator.data('target')).addClass('active');
    }

    var $map = $('.google-map');

    if ($map.length > 0) {
      if (!(typeof window.google === 'object' && window.google.maps)) {
        console.error('Google Maps API is not loaded, cannot display map.');
      } else {
        if (typeof window.mapData !== 'undefined' && Array.isArray(window.mapData.communities) && window.mapData.communities.length) {

          var circleIcon = {
            path: window.google.maps.SymbolPath.CIRCLE,
            fillColor: 'white',
            fillOpacity: 1.0,
            strokeWeight: 5,
            scale: 7,
          }

          // The almighty infowindow
          var infowindow = new window.google.maps.InfoWindow({
            maxWidth: 300,
          });

          infowindow.addListener('domready', function () {
            $('.iw-home-select').on('click', function () {
              selectIwHome($(this));
            });

            $('.iw-home-next').on('click', function () {
              var $nextIndicator = $('.iw-home-select.active').next();

              if ( $nextIndicator.length == 0 ) {
                $nextIndicator = $('.iw-home-select').prevAll().last();
              }

              selectIwHome($nextIndicator);
            });
          });

          var bounds = new window.google.maps.LatLngBounds();

          // Defaults to middle-ish of Calgary
          var center = new window.google.maps.LatLng(51.056716, -114.070442);

          // Set up map
          var map = new window.google.maps.Map($map[0], {
            zoom: 11,
            minZoom: 9,
            center: center,
            fullscreenControl: false,
            mapTypeControl: false,
            rotateControl: false,
            streetViewControl: false,
            scaleControl: false,
            styles: mapStyle,
          });

          // Somewhere to keep our community markers
          var communityMarkers = [];

          $.each(window.mapData.communities, function(key, community) {

            // Set colour for this marker
            circleIcon.strokeColor = community.marker.colour;

            var markerPosition = new window.google.maps.LatLng(community.marker.lat, community.marker.lng);

            // Create the marker but don't assign it to the map
            var marker = new window.google.maps.Marker({
              map: map,
              position: markerPosition,
              title: community.title,
              icon: circleIcon,
              animation: window.google.maps.Animation.DROP,
              status: community.status,
              zIndex: community.marker.zIndex,
            });

            marker.addListener('click', function(event) {
              infowindow.setContent(community.marker.infowindow);
              infowindow.open(map, marker);
              if (event) {
                event.stopPropagation;
              }
            });

            communityMarkers.push(marker);
            if (community.status !== 'archived-communities' && community.status !== 'past-communities') {
              bounds.extend(markerPosition);
            }
          });

          map.addListener('click', function() {
            infowindow.close();
          });

          $('#map-locate').on('click', function() {
            // Try HTML5 geolocation.
            if (navigator.geolocation) {
              $('.archive-map-locate').addClass('loading');
              navigator.geolocation.getCurrentPosition(function(position) {
                var userLocation = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);

                var activeMarkers = communityMarkers.filter(function (marker) {
                  return (marker.status !== 'archived-communities' && marker.status !== 'past-communities');
                });

                var closestMarker = activeMarkers.reduce(function (prev, curr) {
                    var cpos = window.google.maps.geometry.spherical.computeDistanceBetween(userLocation, curr.position);
                    var ppos = window.google.maps.geometry.spherical.computeDistanceBetween(userLocation, prev.position);

                    return cpos < ppos ? curr : prev;
                });

                window.google.maps.event.trigger( closestMarker, 'click' );
                map.setCenter(closestMarker.position);
                $('.archive-map-locate').removeClass('loading');
              }, function() {
                handleLocationError(true, infowindow, map.getCenter());
              });
            } else {
              // Browser doesn't support Geolocation
              handleLocationError(false, infowindow, map.getCenter());
            }
          });

        }
      }
    }

    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      var $newTab = $(e.target);

      if ($newTab.attr('href') === '#mapTab') {
        $('.archive-filters').addClass('d-none');
        $('.archive-map-locate').removeClass('d-none');
        $('.top-bar').addClass('invisible');

        // Add a bounds_changed listener when switching to the tab so that
        // bounds get set correctly on the size of the displayed map
        // TODO: Check if window size has actually changed so that we don't move
        //       the map viewport if the user has manually adjusted it
        window.google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
          // Fit map to bounds and centre
          if (communityMarkers.length === 1) {
            map.setCenter(bounds.getCenter());
          } else {
            map.fitBounds(bounds);
            map.panToBounds(bounds);
            // map.setCenter(bounds.getCenter());
          }
        });
      } else {
        // Call layout on isotop again in case window size has changed
        $('.grid').data('isotope').layout();

        $('.archive-filters').removeClass('d-none');
        $('.archive-map-locate').addClass('d-none');
        $('.top-bar').removeClass('invisible');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive-map.js